import React, { Component } from 'react';
import { Line, Arrow, Circle, Rect, Text, Stage, Layer, Image } from 'react-konva';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faCircle, faSquare, faLongArrowAltRight, faFont, faSquareFull, faUndo, faSave, faBan, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PhotoshopPicker } from 'react-color';
import PropTypes from 'prop-types';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var BaseDrawable = function BaseDrawable(startx, starty) {
  classCallCheck(this, BaseDrawable);
  this.startx = startx;
  this.starty = starty;
};

var FreePathDrawable = function (_BaseDrawable) {
  inherits(FreePathDrawable, _BaseDrawable);

  function FreePathDrawable(startx, starty, color, key) {
    classCallCheck(this, FreePathDrawable);

    var _this = possibleConstructorReturn(this, (FreePathDrawable.__proto__ || Object.getPrototypeOf(FreePathDrawable)).call(this, startx, starty));

    _this.points = [startx, starty];
    _this.key = key;
    _this.color = color;
    return _this;
  }

  createClass(FreePathDrawable, [{
    key: "registerMovement",
    value: function registerMovement(x, y) {
      this.points = [].concat(toConsumableArray(this.points), [x, y]);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Line, {
        points: this.points,
        fill: this.color,
        stroke: this.color,
        key: this.key
      });
    }
  }]);
  return FreePathDrawable;
}(BaseDrawable);

var ArrowDrawable = function (_BaseDrawable) {
  inherits(ArrowDrawable, _BaseDrawable);

  function ArrowDrawable(startx, starty, color, key) {
    classCallCheck(this, ArrowDrawable);

    var _this = possibleConstructorReturn(this, (ArrowDrawable.__proto__ || Object.getPrototypeOf(ArrowDrawable)).call(this, startx, starty));

    _this.x = startx;
    _this.y = starty;
    _this.key = key;
    _this.color = color;
    return _this;
  }

  createClass(ArrowDrawable, [{
    key: "registerMovement",
    value: function registerMovement(x, y) {
      this.x = x;
      this.y = y;
    }
  }, {
    key: "render",
    value: function render() {
      var points = [this.startx, this.starty, this.x, this.y];
      return React.createElement(Arrow, {
        points: points,
        fill: this.color,
        stroke: this.color,
        key: this.key
      });
    }
  }]);
  return ArrowDrawable;
}(BaseDrawable);

var CircleDrawable = function (_ArrowDrawable) {
  inherits(CircleDrawable, _ArrowDrawable);

  function CircleDrawable(startx, starty, color, key) {
    classCallCheck(this, CircleDrawable);

    var _this = possibleConstructorReturn(this, (CircleDrawable.__proto__ || Object.getPrototypeOf(CircleDrawable)).call(this, startx, starty));

    _this.x = startx;
    _this.y = starty;
    _this.key = key;
    _this.color = color;
    return _this;
  }

  createClass(CircleDrawable, [{
    key: "render",
    value: function render() {
      var dx = this.startx - this.x;
      var dy = this.starty - this.y;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return React.createElement(Circle, {
        radius: radius,
        x: this.startx,
        y: this.starty,
        key: this.key,
        stroke: this.color
      });
    }
  }]);
  return CircleDrawable;
}(ArrowDrawable);

var SquareDrawable = function (_ArrowDrawable) {
  inherits(SquareDrawable, _ArrowDrawable);

  function SquareDrawable(startx, starty, color, key) {
    classCallCheck(this, SquareDrawable);

    var _this = possibleConstructorReturn(this, (SquareDrawable.__proto__ || Object.getPrototypeOf(SquareDrawable)).call(this, startx, starty));

    _this.x = startx;
    _this.y = starty;
    _this.key = key;
    _this.color = color;
    return _this;
  }

  createClass(SquareDrawable, [{
    key: "render",
    value: function render() {
      var dx = -(this.startx - this.x);
      var dy = -(this.starty - this.y);
      return React.createElement(Rect, {
        x: this.startx,
        y: this.starty,
        width: dx,
        height: dy,
        key: this.key,
        stroke: this.color
      });
    }
  }]);
  return SquareDrawable;
}(ArrowDrawable);

var TEXT_AREA_ID = "konva-text-editor";

var textareaGenerator = function textareaGenerator(x, y, color, fontFamily, onBlur) {
  var textarea = getTextArea();
  styleTextarea(textarea, x, y, color, fontFamily);
  setupEvents(textarea, onBlur); //Auto focus after creation

  setTimeout(function () {
    textarea.focus();
  }, 100);
};

var getTextArea = function getTextArea() {
  var textarea = document.getElementById(TEXT_AREA_ID);

  if (!textarea) {
    textarea = document.createElement('textarea');
    var canvas = document.getElementsByClassName("konvajs-content")[0];
    canvas.appendChild(textarea);
    textarea.style.position = 'absolute';
    textarea.id = TEXT_AREA_ID;
  }

  return textarea;
};

var styleTextarea = function styleTextarea(textarea, x, y, color, fontFamily) {
  textarea.style.top = y + 'px';
  textarea.style.left = x + 'px';
  textarea.style.width = "20px";
  textarea.style.height = "20px";
  textarea.style.fontSize = '12px';
  textarea.style.border = 'none';
  textarea.style.padding = '0px';
  textarea.style.margin = '0px';
  textarea.style.overflow = 'hidden';
  textarea.style.whiteSpace = 'nowrap';
  textarea.style.background = 'none';
  textarea.style.outline = 'none';
  textarea.style.resize = 'none';
  textarea.style.lineHeight = "12px";
  textarea.style.transformOrigin = 'left top';
  textarea.style.color = color;
  textarea.style.fontFamily = fontFamily;
};

var setupEvents = function setupEvents(textarea, onBlur) {
  textarea.addEventListener('input', function (e) {
    autoExpand(e.target);
  });
  textarea.addEventListener('blur', function (e) {
    removeTextarea();
    onBlur(e);
  });
};

var removeTextarea = function removeTextarea() {
  var elem = document.getElementById(TEXT_AREA_ID);
  elem.parentNode.removeChild(elem);
};

var autoExpand = function autoExpand(field) {
  // Calculate the height
  var height = field.scrollHeight;
  var width = field.scrollWidth;
  field.style.width = width + 'px';
  field.style.height = height + 'px';
};

var TextDrawable = function (_BaseDrawable) {
  inherits(TextDrawable, _BaseDrawable);

  function TextDrawable(startx, starty, color, key) {
    var fontFamily = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Arial';
    classCallCheck(this, TextDrawable);

    var _this = possibleConstructorReturn(this, (TextDrawable.__proto__ || Object.getPrototypeOf(TextDrawable)).call(this, startx, starty));

    _this.key = key;
    _this.color = color;
    _this.fontFamily = fontFamily;
    return _this;
  }

  createClass(TextDrawable, [{
    key: "renderTextArea",
    value: function renderTextArea(onBlur) {
      var _this2 = this;

      textareaGenerator(this.startx, this.starty, this.color, this.fontFamily, function (element) {
        _this2.text = element.target.value;

        if (element.target.value !== "") {
          onBlur(_this2);
        } else {
          onBlur(null);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Text, {
        text: this.text,
        draggable: true,
        x: this.startx,
        y: this.starty,
        fill: this.color,
        key: this.key,
        fontFamily: this.fontFamily
      });
    }
  }]);
  return TextDrawable;
}(BaseDrawable);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".toolbar-module_toolbar__27OLc {\r\n    position: fixed;\r\n    left: 0;\r\n    width: 50px;\r\n    bottom: 0;\r\n    top: 0;\r\n    border: 1px solid rgb(136, 136, 136);\r\n    background: #333;\r\n    border-radius: 5px;\r\n}\r\n.toolbar-module_toolButton__9_BEE {\r\n    overflow: hidden;\r\n    font-size: 18px;\r\n    width: 32px;\r\n    height: 32px;\r\n    background-color: #333;\r\n    box-shadow: 0 0 2px #66a;\r\n    padding: 1px;\r\n    margin: 0;\r\n    cursor: pointer;\r\n}\r\n.toolbar-module_toolbarTable__3rJjE{\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n.toolbar-module_active__1zXru {\r\n    background-color: rgba(0,0,0,.5);\r\n}";
var Styles = {
  "toolbar": "toolbar-module_toolbar__27OLc",
  "toolButton": "toolbar-module_toolButton__9_BEE",
  "toolbarTable": "toolbar-module_toolbarTable__3rJjE",
  "active": "toolbar-module_active__1zXru"
};
styleInject(css);

var ToolbarButton = function ToolbarButton(props) {
  return React.createElement("tr", null, React.createElement("td", {
    onClick: props.onClick,
    className: Styles.toolButton + " " + (props.selected ? Styles.active : "")
  }, props.children));
};

var Toolbar = function (_Component) {
  inherits(Toolbar, _Component);

  function Toolbar(props) {
    classCallCheck(this, Toolbar);

    var _this = possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));

    _this.onColorChange = function (color, e) {
      _this.props.onColorChanged(color.hex);

      _this.setState({
        color: color.hex
      });
    };

    _this.onColorCancel = function (e) {
      _this.setState({
        color: _this.state.defaultColor,
        showColorPicker: false
      });
    };

    _this.onShowColor = function () {
      _this.setState({
        showColorPicker: !_this.state.showColorPicker,
        defaultColor: _this.state.color
      });
    };

    _this.onDrawableChange = function (e) {
      _this.props.onClick(e);

      _this.setState({
        selected: e
      });
    };

    _this.state = {
      showColorPicker: false,
      color: props.defaultColor,
      prevColor: props.defaultColor,
      selected: "FreePathDrawable"
    };
    return _this;
  }

  createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: Styles.toolbar + " sppro-toolbar"
      }, React.createElement("table", {
        className: Styles.toolbarTable
      }, React.createElement("tbody", null, React.createElement(ToolbarButton, {
        selected: this.state.selected === "FreePathDrawable",
        onClick: function onClick(e) {
          return _this2.onDrawableChange("FreePathDrawable");
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faPencilAlt,
        color: "white"
      })), React.createElement(ToolbarButton, {
        selected: this.state.selected === "SquareDrawable",
        onClick: function onClick(e) {
          return _this2.onDrawableChange("SquareDrawable");
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faSquare,
        color: "white"
      })), React.createElement(ToolbarButton, {
        selected: this.state.selected === "CircleDrawable",
        onClick: function onClick(e) {
          return _this2.onDrawableChange("CircleDrawable");
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faCircle,
        color: "white"
      })), React.createElement(ToolbarButton, {
        selected: this.state.selected === "ArrowDrawable",
        onClick: function onClick(e) {
          return _this2.onDrawableChange("ArrowDrawable");
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faLongArrowAltRight,
        color: "white"
      })), React.createElement(ToolbarButton, {
        selected: this.state.selected === "TextDrawable",
        onClick: function onClick(e) {
          return _this2.onDrawableChange("TextDrawable");
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faFont,
        color: "white"
      })), React.createElement(ToolbarButton, null, React.createElement(FontAwesomeIcon, {
        onClick: this.onShowColor,
        icon: faSquareFull,
        color: this.state.color
      })), React.createElement(ToolbarButton, null, React.createElement(FontAwesomeIcon, {
        onClick: this.props.onUndo,
        icon: faUndo,
        color: "white"
      })), React.createElement(ToolbarButton, null, React.createElement(FontAwesomeIcon, {
        onClick: this.props.onClear,
        icon: faBan,
        color: "white"
      })), React.createElement(ToolbarButton, null, React.createElement(FontAwesomeIcon, {
        onClick: this.props.onSave,
        icon: faSave,
        color: "white"
      })))), this.state.showColorPicker && React.createElement(PhotoshopPicker, {
        color: this.state.color,
        onChangeComplete: this.onColorChange,
        onAccept: function onAccept() {
          return _this2.setState({
            showColorPicker: false
          });
        },
        onCancel: this.onColorCancel
      }));
    }
  }]);
  return Toolbar;
}(Component);

var css$1 = ".index-module_centeredBox__33umw{\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n.index-module_overlay__1M37E{\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0,0,0,.6);\r\n    z-index:1000;\r\n}\r\n.index-module_closeButton__2w_Zy {\r\n    position: fixed;\r\n    right: 15px;\r\n    top: 15px;\r\n    cursor: pointer;\r\n}\r\n.index-module_crosshair__1KuK_ {\r\n    cursor: crosshair;\r\n}\r\n.index-module_text__1XA6I { \r\n    cursor: text;\r\n}";
var Styles$1 = {
  "centeredBox": "index-module_centeredBox__33umw",
  "overlay": "index-module_overlay__1M37E",
  "closeButton": "index-module_closeButton__2w_Zy",
  "crosshair": "index-module_crosshair__1KuK_",
  "text": "index-module_text__1XA6I"
};
styleInject(css$1);
var DEFAULT_COLOR = "black";

var SpproImageAnnote = function (_Component) {
  inherits(SpproImageAnnote, _Component);

  function SpproImageAnnote(props) {
    classCallCheck(this, SpproImageAnnote);

    var _this = possibleConstructorReturn(this, (SpproImageAnnote.__proto__ || Object.getPrototypeOf(SpproImageAnnote)).call(this, props));

    _this.onload = function () {
      _this.setState({
        status: 'loaded'
      });
    };

    _this.onerror = function () {
      _this.setState({
        status: 'failed'
      });
    };

    _this.onMouseDown = function (e) {
      var _e$target$getStage$ge = e.target.getStage().getPointerPosition(),
          x = _e$target$getStage$ge.x,
          y = _e$target$getStage$ge.y;

      if (_this.state.newDrawableType === "TextDrawable") {
        if (!_this.state.textAreaInView) {
          var newDrawable = new TextDrawable(x, y, _this.state.color, _this.state.drawables.length);
          newDrawable.renderTextArea(function (textElement) {
            _this.setState({
              textAreaInView: false
            });

            if (textElement) {
              var drawables = _this.state.drawables;
              drawables.push(textElement);

              _this.setState({
                drawables: drawables
              });
            }
          });

          _this.setState({
            textAreaInView: true
          });
        }
      } else {
        var _newDrawable = _this.state.newDrawable;

        if (_newDrawable.length === 0) {
          var _newDrawable2 = _this.getNewDrawableBasedOnType(x, y, _this.state.newDrawableType, _this.state.drawables.length);

          console.log("newDrawable", _newDrawable2);

          _this.setState({
            newDrawable: [_newDrawable2]
          });
        }
      }
    };

    _this.onMouseUp = function (e) {
      if (_this.state.newDrawableType === "TextDrawable") ;else {
        var _this$state = _this.state,
            newDrawable = _this$state.newDrawable,
            drawables = _this$state.drawables;

        if (newDrawable.length === 1) {
          var _e$target$getStage$ge2 = e.target.getStage().getPointerPosition(),
              x = _e$target$getStage$ge2.x,
              y = _e$target$getStage$ge2.y;

          var drawableToAdd = newDrawable[0];
          drawableToAdd.registerMovement(x, y);
          drawables.push(drawableToAdd);

          _this.setState({
            newDrawable: [],
            drawables: drawables
          });
        }
      }
    };

    _this.onMouseMove = function (e) {
      var newDrawable = _this.state.newDrawable;

      if (newDrawable.length === 1) {
        var _e$target$getStage$ge3 = e.target.getStage().getPointerPosition(),
            x = _e$target$getStage$ge3.x,
            y = _e$target$getStage$ge3.y;

        var updatedNewDrawable = newDrawable[0];
        updatedNewDrawable.registerMovement(x, y);

        _this.setState({
          newDrawable: [updatedNewDrawable]
        });
      }
    };

    _this.onDrawableTypeChange = function (drawableType) {
      _this.setState({
        newDrawableType: drawableType
      });

      switch (drawableType) {
        case "TextDrawable":
          _this.setState({
            stageClass: Styles$1.text,
            newDrawableType: drawableType
          });

          break;

        default:
          _this.setState({
            stageClass: Styles$1.crosshair,
            newDrawableType: drawableType
          });

          break;
      }
    };

    _this.onUndo = function () {
      var drawables = _this.state.drawables;

      if (drawables && drawables.length > 0) {
        drawables.pop();
      } else {
        drawables = [];
      }

      _this.setState({
        newDrawable: [],
        drawables: drawables
      });
    };

    _this.onClear = function () {
      _this.setState({
        newDrawable: [],
        drawables: []
      });
    };

    _this.onSave = function () {
      _this.props.onSave(_this.stageRef.toDataURL());
    };

    _this.getNewDrawableBasedOnType = function (x, y, type, key) {
      var drawableClasses = {
        FreePathDrawable: FreePathDrawable,
        ArrowDrawable: ArrowDrawable,
        CircleDrawable: CircleDrawable,
        SquareDrawable: SquareDrawable,
        TextDrawable: TextDrawable
      };
      return new drawableClasses[type](x, y, _this.state.color, key);
    };

    var img = document.createElement('img');
    img.addEventListener('load', _this.onload);
    img.addEventListener('error', _this.onerror);
    img.src = props.url;
    _this.state = {
      img: img,
      drawables: [],
      newDrawable: [],
      newDrawableType: "FreePathDrawable",
      color: DEFAULT_COLOR,
      stageClass: Styles$1.crosshair
    };
    return _this;
  }
  /* Events */

  /* End Events */


  createClass(SpproImageAnnote, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var drawables = [].concat(toConsumableArray(this.state.drawables), toConsumableArray(this.state.newDrawable));

      if (this.state.status === 'loaded') {
        return React.createElement('div', {
          className: Styles$1.overlay + " sppro-overlay"
        }, this.props.onClose && React.createElement('div', {
          className: Styles$1.closeButton
        }, React.createElement(FontAwesomeIcon, {
          onClick: this.props.onClose,
          icon: faTimes,
          color: 'white',
          size: 'lg'
        })), React.createElement(Toolbar, {
          onClick: this.onDrawableTypeChange,
          onColorChanged: function onColorChanged(color) {
            return _this2.setState({
              color: color
            });
          },
          onUndo: this.onUndo,
          onClear: this.onClear,
          onSave: this.onSave,
          defaultColor: DEFAULT_COLOR
        }), React.createElement('div', {
          className: Styles$1.centeredBox
        }, React.createElement('div', null, React.createElement(Stage, {
          onMouseDown: this.onMouseDown,
          onMouseUp: this.onMouseUp,
          onMouseMove: this.onMouseMove,
          width: this.state.img.width,
          height: this.state.img.height,
          className: this.state.stageClass,
          ref: function ref(_ref) {
            _this2.stageRef = _ref;
          }
        }, React.createElement(Layer, null, React.createElement(Image, {
          image: this.state.img
        }), drawables.map(function (drawable) {
          return drawable.render();
        }))))));
      } else return React.createElement('div', null, 'Loading..');
    }
  }]);
  return SpproImageAnnote;
}(Component);

SpproImageAnnote.propTypes = {
  url: PropTypes.string
};
export default SpproImageAnnote;